import React, { useState } from 'react'
import { useSelector} from 'react-redux';
import { Blog } from './Blog'
import { useDispatch } from 'react-redux';
import { allBlogs, filerCategory } from '../redux/actions/actions';

export const BlogList = () => {
    const state=useSelector(state=>state);
    const{filters,blogs}=state;
    const dispatch=useDispatch();
    const [filterCategory,setFilterCategory] = useState('')

    // remove duplicateCategory name
    let categories =[...new Set(blogs?.map(item =>item.category))];

// check Category wise blog
    const filerCategoryBlogs=(blog)=>{
        switch (filters?.category) {
            case blog.category:
                return true;
            case 'all':
                return true;
            default:
                return false;
        }
    }

    // filter author wise blog
    const filterAuthorBlogs=(blog)=>{
        switch (filters?.author) {
            case blog.author:
                return true;
            case 'all':
                return true;
            default:
                return false;
        }
    }
       // filter Title wise Blogs
    const filterTitleBlogs=(blog)=>{
        if(filters.query===''){
            return true
            
        }else{
            if(blog.title.toLowerCase().includes(filters.query.toLowerCase())){
                return true;
            }
            else{
                return false;
            }
        }
    }

    // all blog dispatch
    const handleAllBlogs=()=>{
        dispatch(allBlogs())
        setFilterCategory('')
        
    }

// find category blog
    const handleCategory=(category)=>{
        dispatch(filerCategory(category));
        setFilterCategory(category)
    }
    return (
        <section
        className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8"
    >
        <div className="absolute inset-0">
            <div className="bg-white h-1/3 sm:h-2/3"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto">
        
            <div className="text-center mb-3">
                <h2
                    className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl"
                >
                    ALL BLOGS ARE HERE
                </h2>
                <p
                    className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4"
                >
                    Lorem ipsum dolor sit amet consectetur, adipisicing
                    elit. Ipsa libero labore natus atque, ducimus sed.
                </p>
           
               
            </div>
            
            
            
           <button onClick={handleAllBlogs} className="mx-5 my-5 bg-indigo-100 px-3 py-0.5 rounded-full float-right text-m font-semibold text-indigo-800">All Blogs</button>
          {filterCategory?.length>1?<><button onClick={()=>handleCategory(filterCategory)} className="mx-5 bg-indigo-100 px-3 py-0.5 rounded-full float-right text-m font-semibold text-indigo-800">{filterCategory}</button></>:<>
          {
                categories?.map((category,i)=><>
                    <button onClick={()=>handleCategory(category)} key={i} className="mx-5 bg-indigo-100 px-3 py-0.5 rounded-full float-right text-m font-semibold text-indigo-800">{category}</button>
                </>)
            }
          </>}
            <div
                className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none"
            >
            
            {
                blogs&&blogs
                .filter(filterTitleBlogs)
                .filter(filerCategoryBlogs)
                .filter(filterAuthorBlogs)
                .map((blog,i)=><Blog blog={blog} key={i}/>)
            }
              </div>
              
            </div>
        </section>
    )
}
